import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sendPackageOperationalEvent } from '../../../common/utils';
import { Logger } from '../../../common/utils/logger';
import { isThirdPartyAllowed } from '../third-party-verification';
export var checkThirdParty = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thirdParty, onAllowed, onDenied) {
    var isAllowed;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return isThirdPartyAllowed(thirdParty);
        case 3:
          isAllowed = _context.sent;
          sendPackageOperationalEvent({
            action: 'usedCheckThirdParty',
            attributes: {
              wasRejected: !isAllowed,
              thirdParty: thirdParty
            }
          });
          return _context.abrupt("return", isAllowed ? onAllowed() : onDenied === null || onDenied === void 0 ? void 0 : onDenied());
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          Logger.errorWithOperationalEvent({
            action: 'checkThirdPartyError',
            attributes: {
              wasRejected: true,
              thirdParty: thirdParty
            },
            message: "Failed to use check third party. ".concat(_context.t0.message || '')
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function checkThirdParty(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();